import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function ProgressCircle({ showProgress, color }) {


  return (
    <>
      {showProgress === true ? <CircularProgress size={30} /> : ""}
    </>
  );
}